let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8AsLT")).then(() => parcelRequire('8XEjR'));